import request from '@utils/request';

import {
  STEP_ALTERNATIVES,
  STEP_CONTACT_INFO,
  STEP_DOCUMENTS,
  STEP_SUBMITTED,
} from '@common/constants/jobs';
import * as endpoints from '@common/endpoints';

const formFieldsToJobApplyBody = (values, isSpontaneous = false) => ({
  acknowledgement: values.acknowledgement,
  closedForAlteration: values.closedForAlteration,
  email: values.email,
  firstName: values.firstName,
  gender: values.gender,
  language: values.language,
  lastName: values.lastName,
  otherJobOffers: values.otherJobOffers,
  phone: values.phoneNumber ? values.mobilePhone : '',
  primaryJobOffer: values.primaryJobOffer,
  spontaneousApplication: isSpontaneous,
});

const jobApplyBodyToFormFields = data => ({
  acknowledgement: data.acknowledgement,
  closedForAlteration: data.closedForAlteration,
  email: data.email,
  firstName: data.firstName,
  gender: data.gender?.toString(),
  lastName: data.lastName,
  mobilePhone: data.phone,
  otherJobOffers: data.otherJobOffers,
  primaryJobOffer: data.primaryJobOffer,
  uuid: data.uuid,
});

const submitContactInfo = async (values, isSpontaneous) => {
  const body = formFieldsToJobApplyBody(values, isSpontaneous);

  const { data } = await request.post(endpoints.jobsCreateApplication(), body);

  const parsedData = jobApplyBodyToFormFields(data);

  return {
    ...parsedData,
    step: STEP_DOCUMENTS,
  };
};

const submitDocuments = async (values, isLastStep, isSpontaneous) => {
  const body = formFieldsToJobApplyBody(
    {
      ...values,
      closedForAlteration: isLastStep,
    },
    isSpontaneous,
  );

  const { data } = await request.patch(
    endpoints.jobsUpdateApplication(values.uuid),
    body,
  );

  const parsedData = jobApplyBodyToFormFields(data);

  return {
    ...parsedData,
    step: isLastStep ? STEP_SUBMITTED : STEP_ALTERNATIVES,
  };
};

const submitAlternatives = async (values, isSpontaneous) => {
  const body = formFieldsToJobApplyBody(
    {
      ...values,
      closedForAlteration: true,
    },
    isSpontaneous,
  );

  const { data } = await request.patch(
    endpoints.jobsUpdateApplication(values.uuid),
    body,
  );

  const parsedData = jobApplyBodyToFormFields(data);

  return {
    ...parsedData,
    step: STEP_SUBMITTED,
  };
};

export const submitJobApplyForm = (
  values,
  isLastStep,
  isSpontaneous = false,
) => {
  const { step } = values;

  if (step === STEP_CONTACT_INFO) {
    return submitContactInfo(values, isSpontaneous);
  }

  if (step === STEP_DOCUMENTS) {
    return submitDocuments(values, isLastStep, isSpontaneous);
  }

  if (step === STEP_ALTERNATIVES) {
    return submitAlternatives(values, isSpontaneous);
  }

  return null;
};

export const jobApplyFormFieldsMap = {
  email: 'email',
  firstname: 'firstName',
  gender: 'gender',
  language: 'language',
  lastname: 'lastName',
  phone: 'mobilePhone',
};

const MAX_FILE_SIZE = 10485760; // 10MB

export const FILE_VALIDATION_INCOMPLETE_UPLOAD = 'incompleteUpload';
export const FILE_VALIDATION_TYPE_ERROR = 'invalidType';
const FILE_VALID_TYPES = ['application/pdf'];

export const validateJobApplyFile = file => {
  const errors = [];

  if (!FILE_VALID_TYPES.includes(file.type)) {
    errors.push(FILE_VALIDATION_TYPE_ERROR);
  }

  if (file.size > MAX_FILE_SIZE) {
    errors.push(FILE_VALIDATION_INCOMPLETE_UPLOAD);
  }

  return errors;
};
